import data from "../data";
import customers from '../data/customers';
import products from '../data/products'

const maxSize = process.env.REACT_APP_MAX_UPLOAD_SIZE;
const mimeTypes = process.env.REACT_APP_UPLOAD_MIME_TYPES.split(",");

const file = input => {
    if (mimeTypes.indexOf(input.type) === -1) {
        return {
            isValid: false,
            error: data.copy("fileTypeMustBe")
        };
    }
    if (input.size > maxSize) {
        return {
            isValid: false,
            error: data.copy("maxFileSizeIs").replace('{MAXSIZE}', maxSize)
        };
    }
    return {
        isValid: true
    };
};

const params = ({price, currencyId, token, method, journey, productId, agp, diageoGateway, }) => {

    let isJourney = false;

    if (undefined !== journey) {

        isJourney = true;

        if(["instore", "instoreba", "retailer"].indexOf(journey) === -1) {  //todo this should be moved somewhere in order not to have 2 definitions (other one in App.js)
            return {
                error: {
                    heading: 'Error',
                    title: 'Invalid Journey',
                    message: 'Please provide us with a valid journey'
                }
            }
        }
        if(agp === 'true'&& !diageoGateway){
          return {
            error: {
                heading: 'Error',
                title: 'Missing diageoGateway',
                message: 'Please provide us with a diageoGateway '
            }
        } 
        }
    }

    if (!isJourney && !token) {
        return {
            error: {
                heading: 'Error',
                title: 'Missing Token',
                message: 'Please provide us with a token'
            }
        }
    }

    if (!isJourney && !customers[token]) {
        return {
            error: {
                heading: 'Error',
                title: 'Invalid Token',
                message: 'A valid token must be provided'
            }
        }
    }

    if (!isJourney && !productId) {
        return {
            error: {
                heading: 'Error',
                title: 'Missing productId',
                message: 'Please provide us with a productId'
            }
        }
    }

    let validProductFound = products.find(element => {
        return element.id === productId
    });

    if(!isJourney && !validProductFound) {
        return {
            error: {
                heading: 'Error',
                title: 'Invalid productId',
                message: 'A valid productId mnust be provided'
            }
        }
    }

    if (!isJourney && !method) {
        return {
            error: {
                heading: 'Error',
                title: 'Missing Method',
                message: 'A valid method must be provided'
            }
        }
    }

    if (!isJourney && (undefined !== method && ["script", "redirect"].indexOf(method) === -1)) {    //todo same as above
        return {
            error: {
                heading: 'Error',
                title: 'Invalid method',
                message: 'Please provide us with a valid method'
            }
        }
    }

    if (!isJourney && (price && !currencyId)) {
        return {
            error: {
                heading: 'Error',
                title: 'Missing currencyId',
                message: `When providing a price a currencyId must also be provided`
            }
        };
    }

    if (!isJourney && (price && !data.currencies[currencyId])) {
        return {
            error: {
                heading: 'Error',
                title: `currencyId "${currencyId}" not found.`,
                message: ''
            }
        };
    }

    return {};
};

export default {file, params};



// WEBPACK FOOTER //
// ./src/misc/validate.js